<script>
import Modal from '@phoenix/mixins/components/common/Modal';
import ModalCloseButton from '@maison/components/common/ModalCloseButton.vue';

export default {
  components: {
    ModalCloseButton,
  },

  mixins: [Modal],

  props: {
    hasContentBaseClass: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      defaultOptions: {
        overlayClass: 'modal__overlay',
        containerClass: 'modal__container',
      },
    };
  },

  computed: {
    _classes() {
      return [
        'modal',
        {
          'modal--medium': this.isMedium,
          'modal--small': this.small,
          'modal--large': this.large,
          'modal--full': this.fullscreen,
          'modal--naked': this.naked,
        },
        ...this.classes,
      ];
    },

    _headerClasses() {
      return ['modal__header', { 'modal__header--bordered': this.headerBordered }, ...this.headerClasses];
    },

    _contentClasses() {
      return [{ modal__content: this.hasContentBaseClass }, ...this.contentClasses];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="modal__overlay" tabindex="-1">
      <modal-close-button v-if="closeButtonOutside" :modal-id="id" />
      <div
        class="modal__container"
        role="dialog"
        aria-modal="true"
        v-bind="{ [shouldDisplayHeader ? 'aria-labelledby' : 'aria-label']: `${id}-title` }"
        :data-cy="dataCy"
      >
        <header v-if="shouldDisplayHeader" :class="_headerClasses">
          <h2 :id="`${id}-title`" class="modal__title h5">
            {{ title }}
          </h2>

          <modal-close-button :modal-id="id" />
        </header>
        <modal-close-button v-else-if="!closeButtonOutside" :modal-id="id" />

        <slot name="header" />

        <main v-if="shouldWrapContent" :id="`${id}-content`" :class="_contentClasses">
          <slot name="content" />
        </main>
        <slot v-else name="content" />

        <footer v-if="hasFooterSlot" class="modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>
